module.exports = __webpack_public_path__ + "static/locate-icon-6f4a6ff74ea7af9d56f908f8b65b49b2.png";